<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md6
      >
        <material-card
          color="green"
          :title="courseDetail.name + ' | Subject list'"
          text="The courses those are being provided by BacBon"
        >
        <!-- {{ courseDetails.name }} -->
          <v-data-table
            :headers="headers"
            :items="courseSubjectList"
            
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td><router-link :to="'/subject-details/'+ $route.params.id + '/' + item.subject_id"> {{ item.name }}</router-link></td>
              <td>{{ item.color_name }}</td>
            </template>
          </v-data-table>
        </material-card>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div>{{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
      <v-flex
        xs12
        md6
      >
      
        <material-card
          color="green"
          title="Add Subject"
          text="Select a subject and hit submit"
        >
        
        <v-select
          :items="subjectListNotInCourse"
          label="Select Subject"
          item-text="name"
          item-value="id"
          v-model="subjectId"
          class="mt-4"
        ></v-select>

       
          <v-flex class="md12">
            <v-text-field type="text" 
              label="Price"
              v-model="price"
              class="green-input"
              :rules="priceRule"
          />
                
          </v-flex>
            <v-flex
              xs12
              text-xs-right>
              <v-btn
                class="mx-0 font-weight-light"
                color="success"
                @click="submitSubject"
                >Submit</v-btn>
            </v-flex> 
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
    metaInfo () {
    return {
      title: 'Course Details | Admin'
    }
  },
  components: {
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('course_subjects', ['courseSubjectList', 'subjectListNotInCourse', 'courseDetail']),
  },
  mounted () {
    this.getCourseSubjectList(this.$route.params.id)
    this.getCourseDetails(this.$route.params.id)
    this.getSubjectListNotInCourse(this.$route.params.id)
  },
  data () {
    return {
    color: null,
    subjectId: Number,
    price: '',
    colors: [
      'warning'
    ],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
    headers: [
      {
        sortable: true,
        text: 'Course',
        value: 'name'
      },
      {
        sortable: true,
        text: 'Color name',
        value: 'color_name'
      },
    ],
      dialog: false,
      noticeMessage: '',
      valueObj: { },
      
    priceRule: [
      v => !!v || 'Price is required.',
      v => /^(\d*([.,](?=\d{1}))?\d+)+((?!\2)[.,]\d\d)?$/.test(v) || 'Input '
    ],
    }
  },
  created () {
  },
  methods: {
    ...mapActions("course_subjects", ["fetchData","CreateCourse", "getCourseSubjectList", "getSubjectListNotInCourse", "addSubjectToCourse", "getCourseDetails"]),
    submitSubject () {
        let obj = {
            'course_id': JSON.parse(this.$route.params.id),
            'subject_id': this.subjectId,
            'price': JSON.parse(this.price),
            'status': 'Available',
        }
        // console.log(obj)
        this.addSubjectToCourse(obj).then((response)=> {
            if (response.status == 'OK') {
            this.getCourseSubjectList(this.$route.params.id)
            this.getSubjectListNotInCourse(this.$route.params.id)
            this.color= 'success'
            this.subjectId= null
            this.price= null
            this.noticeMessage = 'Success! ' + response.messages
            this.snack('top')
            } else {
            this.color= 'warning'
            this.noticeMessage ='Warning! ' + response.messages
            this.snack('top')
            }
        })
    },
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }

    //   this.color = this.colors[Math.floor(Math.random() * this.colors.length)]

      this.snackbar = true
    }
  }
}
</script>
